import { defineComponent as _defineComponent } from 'vue'
import { keyBy } from 'lodash';
import { NotificationProgrammatic } from 'buefy';
import { ref } from 'vue';
import { ArSubmissionElement, ArSubmissionStatus, WorkOrder } from '@newmoon-org/types';

import { formatDate } from '@/service/dateFormatting.service';
import WorkOrdersService from '@/service/workorders.service';

import { useStore } from '@/store';


export default /*#__PURE__*/_defineComponent({
  __name: 'WorkOrderARSubmission',
  props: {
    workOrder: null
  },
  emits: ["arSubmissionUpdated"],
  setup(__props: any, { emit: emits }: { emit: ({
  (eventName: 'arSubmissionUpdated', { value }: { value: ArSubmissionElement }): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  workOrder: WorkOrder;
}





const store = useStore();
const user = store.getters['auth/user'];

const internalWorkOrder = ref<WorkOrder>(props.workOrder);
const isSaving = ref<boolean>(false);
const currentStatus = ref<ArSubmissionStatus>(ArSubmissionStatus.Start);
const progressionMap = ref<Record<string, ArSubmissionElement>>();
const statuses = ref<string[]>(Object.values(ArSubmissionStatus));
const arSubmissions = internalWorkOrder.value?.accountingTag?.arSubmissions ?? [];

const length = arSubmissions.length;
const currentArStatus: ArSubmissionElement | undefined = length > 0 ? arSubmissions[length - 1] : undefined;
progressionMap.value = keyBy(arSubmissions, 'status');
currentStatus.value = currentArStatus?.status ?? ArSubmissionStatus.Start;

async function updateStatus(): Promise<void> {
  isSaving.value = true;
  const arSubmission: ArSubmissionElement = {
    createdAt: new Date(),
    createdBy: user.employee.id,
    employeeCode: user.employee.code,
    employeeName: `${user.employee.lastName} ${user.employee.firstName}`,
    status: currentStatus.value,
  };

  arSubmissions.push(arSubmission);

  await WorkOrdersService.mergeUpdate(internalWorkOrder.value.id, {
    accountingTag: {
      ...internalWorkOrder.value?.accountingTag,
      arSubmissions,
    },
  }).then(() => {
    isSaving.value = false;
    NotificationProgrammatic.open({
      message: 'Successfully Recorded AR Submission',
      type: 'is-success',
    });
    progressionMap.value = keyBy(arSubmissions, 'status');
    emits('arSubmissionUpdated', { value: arSubmission });
  });
}

function getHistory(status: string): string {
  if (!progressionMap.value) return '';
  const progress: ArSubmissionElement = progressionMap.value[status];
  return progress?.employeeName ? `(${formatDate(progress.createdAt as Date)}` : '';
}

return { __sfc: true,props, emits, store, user, internalWorkOrder, isSaving, currentStatus, progressionMap, statuses, arSubmissions, length, currentArStatus, updateStatus, getHistory }
}

})